module.exports = __webpack_public_path__ + "img/ams_new_logo.1753c041.png";